import axios from "../../plugins/axios";
import utils from "../../../utils/utils2";  //utils中已经import了user，为了防止彼此引用问题，新做的一个utils


// 字典模块
class Dictionary {

    //INTF-00229：按照请求体获取数据对象下各种下拉字段的下拉选项值
    async getTypes(obj, tag) {
        let body = { object_name: obj, tag: tag };
        try {
            let res = await axios.post(`/myBasicDataApp/service.dictionary.DictionaryProvider/FindAllByObject`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.dictionary_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get catlog list failed: INTF-00229", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00231：对新建的下拉字段内容值进行保存
    creatNew(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.dictionary.DictionaryProvider/CreateOne`, body);
    }

    //INTF-00236：修改名称、备注、生失效
    update(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.dictionary.DictionaryProvider/UpdateName`, body);
    }

    //INTF-00239：批量禁用
    batchEnableOrDisable(body) {
        return axios.post(`/myMaterialApp/service.DictionaryProvider/UpdateActived`, body);
    }

    //INTF-00240：分页获取清单内容
    async getList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myBasicDataApp/service.dictionary.DictionaryProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.dictionary_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get catlog list in pages failed: INTF-00240", err);
            return { err: true, msg: err.response.data };
        }
    }


}

export default Dictionary;